const socket = {
  state: {
    token: ''
  },
  mutations: {
    SET_SOCKET_OPEND: (state, token) => {
      state.token = token
    }
  },
  actions: {
    setSocketopend({ commit }, token) {
      commit('SET_SOCKET_OPEND', token)
    }
  }
}

export default socket
